import { Button } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { QueueDashboardQueueType } from 'lib-dashboard-types';
import { ampli } from 'lib-shared-tracking';
import { memo, useCallback } from 'react';

import { useDashboardLandingPage } from 'app/views/layout/views/dashboard/utils/useDashboardLandingPage';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useAppSearchParams } from 'utils/url/useAppSearchParams';

import { queueTypePresets } from '../../utils/queueTypePresets';

import styles from './queueDashboardFilterControlPresets.module.scss';

export const QueueDashboardFilterControlPresets = memo(
  function QueueDashboardFilterControlPresets(): JSX.Element {
    const { params, replaceParams } = useAppSearchParams('/dashboard/queues');
    const flags = useFeatureFlag(['dashboard-enhanced-favorites']);
    const { setLandingPage } = useDashboardLandingPage();

    const handleChangeQueueType = useCallback(
      (type: QueueDashboardQueueType) => {
        replaceParams({
          type,
          q: params.q,
          sort_by: params.sort_by,
        });

        ampli.dashboardQueuesTypeChanged({
          type,
          location: 'dropdown',
        });

        setLandingPage({
          type: 'last_visited',
          url: {
            path: '/dashboard/queues',
            params: {
              search: {
                type,
                sort_by: params.sort_by,
              },
            },
          },
        });
      },
      [params.q, params.sort_by, replaceParams, setLandingPage],
    );

    return (
      <div
        className={classNames(styles.presets, {
          [styles.presetsOld]: !flags.dashboardEnhancedFavorites,
        })}
      >
        {Array.from(queueTypePresets)
          .filter(([type]) =>
            type === 'favourite' ? !flags.dashboardEnhancedFavorites : true,
          )
          .map(([type, { label, icon }]) => {
            const isSelected = type === params.type;

            return (
              <Button
                key={type}
                variant={isSelected ? 'primary' : 'secondary'}
                size="large"
                icon={flags.dashboardEnhancedFavorites ? undefined : icon}
                onClick={() => {
                  if (!isSelected) {
                    handleChangeQueueType(type as QueueDashboardQueueType);
                  }
                }}
              >
                {label}
              </Button>
            );
          })}
      </div>
    );
  },
);
